import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    list: {
        flex: "1",
        overflow: "hidden",
        overflowY: 'auto',
        position: "relative",
    },
}))